/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Creates a static map. Browser only!
 */

export const getStaticMap = () => {
  const staticMap = new Map<string | null, string>()
  const staticSections = Array.from(document.querySelectorAll('[data-static-section]'))
  for (const element of staticSections) {
    const name = element.getAttribute('data-static-section')
    const html = element.innerHTML
    staticMap.set(name, html)
  }
  return staticMap
}
